const wordSets = [
  {
    setId: 1,
    title: 'basic',
    about: 'With 2,500 to 3,000 words, you can understand 90% of everyday English conversations, English newspaper and magazine articles, and English used in the workplace. The remaining 10% youll be able to learn from context, or ask questions about. However, its essential to learn the right English vocabulary words, so you dont waste your time trying to memorize a huge collection with very little benefit. The list below seems long, but when you can use all these words with confidence, your English vocabulary will be fully functional.',
    words: [
      {
        word: 'adress',
        translation: 'адрес',
        imageUrl: 'https://images.unsplash.com/photo-1517836129990-d2480d8cb126?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1287&q=80',
        progress: 0,
        isNew: true,
      },
      {
        word: 'angle',
        translation: 'угол',
        imageUrl: 'https://images.unsplash.com/photo-1622605831571-261139449967?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2670&q=80',
        progress: 0,
        isNew: true,
      },
      {
        word: 'breast',
        translation: 'грудь',
        imageUrl: 'https://images.unsplash.com/photo-1584090170129-4d74e3634910?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1760&q=80',
        progress: 0,
        isNew: true,
      },
      {
        word: 'bunch',
        translation: 'букет',
        imageUrl: 'https://images.unsplash.com/photo-1513619147533-b39694f87b86?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=927&q=80',
        progress: 0,
        isNew: true,
      },
      {
        word: 'cold',
        translation: 'холод',
        imageUrl: 'https://images.unsplash.com/photo-1519944159858-806d435dc86b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2670&q=80',
        progress: 0,
        isNew: true,
      },
      
    ]
  },
  {
    setId: 2,
    title: 'animal',
    about: 'When learning English, you are likely to come across a lot of animals, each of these has its own name. There is a range of animal types and it is often easier to learn the names of these animals by type',
    words: [
      {
        word: 'dog',
        translation: 'собака',
        imageUrl: 'https://images.unsplash.com/photo-1552053831-71594a27632d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1262&q=80',
        progress: 0,
        isNew: true,
      },
      {
        word: 'ant',
        translation: 'муравей',
        imageUrl: 'https://images.unsplash.com/photo-1510940753358-0c6d35aa3981?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2670&q=80',
        progress: 0,
        isNew: true,
      },
      {
        word: 'horse',
        translation: 'лошадь',
        imageUrl: 'https://images.unsplash.com/photo-1553284965-83fd3e82fa5a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2671&q=80',
        progress: 0,
        isNew: true,
      },
      {
        word: 'dolphin',
        translation: 'дельфин',
        imageUrl: 'https://images.unsplash.com/photo-1611890129309-31e797820019?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2670&q=80',
        progress: 0,
        isNew: true,
      },
      {
        word: 'hedgehog',
        translation: 'еж',
        imageUrl: 'https://images.unsplash.com/photo-1568431477192-52bb13a55088?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2670&q=80',
        progress: 0,
        isNew: true,
      },
      
    ]
  },
  {
    setId: 3,
    title: 'food',
    about: 'The words below are some of the most important used to talk about how food tastes, the condition it is in, and how we cook.',
    words: [
      {
        word: 'icecream',
        translation: 'мороженое',
        imageUrl: 'https://images.unsplash.com/photo-1497034825429-c343d7c6a68f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1287&q=80',
        progress: 0,
        isNew: true,
      },
      {
        word: 'braed',
        translation: 'хлеб',
        imageUrl: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2672&q=80',
        progress: 0,
        isNew: true,
      },
      {
        word: 'jam',
        translation: 'джем',
        imageUrl: 'https://images.unsplash.com/photo-1590083052217-3c5ca32f3906?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1287&q=80',
        progress: 0,
        isNew: true,
      },
      {
        word: 'milk',
        translation: 'молоко',
        imageUrl: 'https://images.unsplash.com/photo-1600788907416-456578634209?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1350&q=80',
        progress: 0,
        isNew: true,
      },
      {
        word: 'chocolate',
        translation: 'шоколад',
        imageUrl: 'https://images.unsplash.com/photo-1610450949065-1f2841536c88?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1287&q=80',
        progress: 0,
        isNew: true,
      },
      
    ]
  },
  {
    setId: 4,
    title: 'travel',
    about: 'Traveling can make even the best storyteller speechless. Get ready for a little vocab lesson where you’ll learn some travel words that describe your wanderlusting perfectly. Guaranteed you’ll wish there was an English equivalent!',
    words: [
      {
        word: 'car',
        translation: 'автомобиль',
        imageUrl: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2670&q=80',
        progress: 0,
        isNew: true,
      },
      {
        word: 'road',
        translation: 'дорога',
        imageUrl: 'https://images.unsplash.com/photo-1542242476-5a3565835a38?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1287&q=80',
        progress: 0,
        isNew: true,
      },
      {
        word: 'journey',
        translation: 'путешествие',
        imageUrl: 'https://images.unsplash.com/reserve/91JuTaUSKaMh2yjB1C4A_IMG_9284.jpg?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2670&q=80',
        progress: 0,
        isNew: true,
      },
      {
        word: 'passport',
        translation: 'паспорт',
        imageUrl: 'https://images.unsplash.com/photo-1553697388-94e804e2f0f6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1365&q=80',
        progress: 0,
        isNew: true,
      },
      {
        word: 'airport',
        translation: 'аэропорт',
        imageUrl: 'https://images.unsplash.com/photo-1554123168-b400f9c806ca?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2670&q=80',
        progress: 0,
        isNew: true,
      },
      
    ]
  }
]

const wordSetList = [
  {
    setId: 1,
    title: 'basic',
    setImageUrl: 'https://images.unsplash.com/photo-1613391781181-2ff9a71e30a5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2148&q=80',
  },
  {
    setId: 2,
    title: 'animal',
    setImageUrl: 'https://images.unsplash.com/photo-1517849845537-4d257902454a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1335&q=80',
  },
  {
    setId: 3,
    title: 'food',
    setImageUrl: 'https://images.unsplash.com/photo-1606787366850-de6330128bfc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2670&q=80',
  },
  {
    setId: 4,
    title: 'travel',
    setImageUrl: 'https://images.unsplash.com/photo-1488646953014-85cb44e25828?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80',
  },
]

const userWords = [
  {
    word: 'plane',
    translation: 'самолет',
    imageUrl: 'https://images.unsplash.com/photo-1512289984044-071903207f5e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3540&q=80',
    progress: 20,
    isNew: false,
  },
  {
    word: 'flower',
    translation: 'цветок',
    imageUrl: 'https://images.unsplash.com/photo-1525310072745-f49212b5ac6d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1365&q=80',
    progress: 70,
    isNew: false,
  },
  {
    word: 'box',
    translation: 'коробка',
    imageUrl: 'https://images.unsplash.com/photo-1607166452427-7e4477079cb9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2670&q=80',
    progress: 10,
    isNew: false,
  },
  {
    word: 'book',
    translation: 'книга',
    imageUrl: 'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2730&q=80',
    progress: 5,
    isNew: false,
  },
  {
    word: 'bag',
    translation: 'сумка',
    imageUrl: 'https://images.unsplash.com/photo-1590874103328-eac38a683ce7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1338&q=80',
    progress: 35,
    isNew: false,
  },
  {
    word: 'charger',
    translation: 'зарядка',
    imageUrl: 'https://images.unsplash.com/photo-1557767382-97b28f5488e7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2670&q=80',
    progress: 89,
    isNew: false,
  },
  {
    word: 'phone',
    translation: 'телефон',
    imageUrl: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1760&q=80',
    progress: 60,
    isNew: false,
  },
  {
    word: 'duck',
    translation: 'утка',
    imageUrl: 'https://images.unsplash.com/photo-1625690487655-bf01fed2fb11?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2670&q=80',
    progress: 100,
    isNew: false,
  },
  {
    word: 'cat',
    translation: 'кошка',
    imageUrl: 'https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2343&q=80',
    progress: 100,
    isNew: false,
  },
]

const defaultImageUrl = 'https://images.unsplash.com/photo-1592431913823-7af6b323da9b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2670&q=80'


export {
  wordSets,
  wordSetList,
  userWords,
  defaultImageUrl
}